var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"viewing"},[_vm._v("\n        "+_vm._s(this.schedule.date)+" - "+_vm._s(this.schedule.amount_due)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"editing"})])
}
var staticRenderFns = []

export { render, staticRenderFns }